// src/pages/LoyaltyScreen.js
import React from 'react';
import { useApp } from '../lib/AppContext';
import { t } from '../lib/i18n';
import { getLoyaltyTier } from '../lib/currency';

export default function LoyaltyScreen() {
  const { lang, profile } = useApp();
  const pts = profile?.loyalty_points || 0;
  const tier = getLoyaltyTier(pts);

  const tiers = [
    { id:'stone',   label: t('stone_tier', lang),   min:0,    max:499,  discount:'5%',  perks:['5% off every order','Member-only pricing'] },
    { id:'crystal', label: t('crystal_tier', lang), min:500,  max:1999, discount:'10%', perks:['10% off every order','Early access to new drops','Priority support'] },
    { id:'elite',   label: t('elite_tier', lang),   min:2000, max:null, discount:'15%', perks:['15% off every order','Free shipping always','Exclusive reserve items','Personal collector advisor'] },
  ];

  return (
    <div style={{ maxWidth: 700, margin:'0 auto', padding:'32px 24px' }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.8rem', letterSpacing:'.05em', marginBottom:4 }}>{t('loyalty_title', lang)}</h2>
      <p style={{ color:'#666', fontSize:'.88rem', fontWeight:300, marginBottom:28 }}>{t('earn_info', lang)}</p>

      <div style={{ background:'rgba(76,202,116,.08)', border:'1px solid rgba(76,202,116,.2)', borderRadius:20, padding:24, marginBottom:24 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
          <div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.72rem', color:'#4cca74', letterSpacing:'.15em', textTransform:'uppercase', marginBottom:4 }}>Your tier</div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.5rem', letterSpacing:'.04em' }}>{tier.label}</div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'2.2rem', color:'#4cca74', lineHeight:1 }}>{pts}</div>
            <div style={{ fontSize:'.72rem', color:'#555', fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:'.08em', textTransform:'uppercase' }}>points</div>
          </div>
        </div>
        {tier.nextTier && (
          <>
            <div style={{ background:'rgba(255,255,255,.06)', borderRadius:4, height:6, marginBottom:8 }}>
              <div style={{ height:'100%', background:'#4cca74', borderRadius:4, width:`${Math.min(100,(pts/tier.nextAt)*100)}%`, transition:'width .6s ease' }} />
            </div>
            <div style={{ fontSize:'.75rem', color:'#666' }}>{tier.nextAt - pts} {t('pts_to_next', lang)}</div>
          </>
        )}
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {tiers.map(tr => {
          const current = tier.tier === tr.id;
          return (
            <div key={tr.id} style={{ background: current ? 'rgba(76,202,116,.06)' : '#111', border:`1px solid ${current ? 'rgba(76,202,116,.3)' : 'rgba(255,255,255,.07)'}`, borderRadius:16, padding:20 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'1rem', fontWeight:700, letterSpacing:'.06em', textTransform:'uppercase', color: current ? '#4cca74' : '#f4f4f4' }}>{tr.label}</div>
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.3rem', color:'#4cca74' }}>{tr.discount} off</div>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
                {tr.perks.map((perk, i) => (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:8, fontSize:'.84rem', color: current ? '#ccc' : '#666' }}>
                    <span style={{ color:'#4cca74', fontSize:'.7rem' }}>✦</span> {perk}
                  </div>
                ))}
              </div>
              {!current && tr.min > pts && (
                <div style={{ marginTop:10, fontSize:'.75rem', color:'#444', fontStyle:'italic' }}>{tr.min - pts} more points needed</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
